import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

interface MarkdownDescriptionProps {
  content: string;
  className?: string;
}

/**
 * Renders markdown content with restricted elements for security.
 * Only allows paragraphs, lists, and line breaks.
 * Used for service descriptions that support bullet points.
 */
export function MarkdownDescription({ content, className }: MarkdownDescriptionProps) {
  if (!content) return null;

  return (
    <div className={cn('prose prose-sm max-w-none', className)}>
      <ReactMarkdown
        allowedElements={['p', 'ul', 'ol', 'li', 'br', 'strong', 'em']}
        unwrapDisallowed={true}
        components={{
          // Custom styling for lists to match the design
          ul: ({ children }) => (
            <ul className="list-disc list-inside space-y-1 my-1">{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className="list-decimal list-inside space-y-1 my-1">{children}</ol>
          ),
          li: ({ children }) => (
            <li className="text-inherit">{children}</li>
          ),
          p: ({ children }) => (
            <p className="my-1">{children}</p>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
